import { Reveal, MaskLines } from "./Reveal";

export const Kicker = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-2 border border-gold/40 bg-onyx/60 px-3 py-1.5 font-cinzel text-[10px] uppercase tracking-[0.35em] text-gold ${className}`}>
    <span className="h-1 w-1 rotate-45 bg-gold" aria-hidden="true" />
    {children}
  </span>
);

// Cinematic page header used across inner pages. `dark` kept for API compat.
export const PageHeader = ({ kicker, titleLines, subtitle, dark = false }) => (
  <section className="grain-dark relative overflow-hidden border-b border-gold/25 bg-onyx text-cream">
    <div className="pointer-events-none absolute left-1/3 top-1/2 h-[70vmin] w-[70vmin] -translate-x-1/2 -translate-y-1/2 rounded-full" style={{ background: "radial-gradient(circle, rgba(201,162,39,0.1) 0%, transparent 60%)" }} />
    <div className="halftone-gold pointer-events-none absolute inset-0 opacity-[0.04]" />
    <div className="relative mx-auto max-w-[1400px] px-4 py-20 sm:px-6 sm:py-28">
      {kicker && <Kicker>{kicker}</Kicker>}
      <h1 className="mt-6 font-display text-5xl uppercase leading-[0.85] tracking-tight text-metallic sm:text-7xl md:text-8xl">
        <MaskLines lines={titleLines} />
      </h1>
      {subtitle && (
        <Reveal delay={0.2} className="mt-6 max-w-2xl">
          <p className="font-body text-lg leading-relaxed text-silver sm:text-xl">{subtitle}</p>
        </Reveal>
      )}
      <div className="gold-rule mt-10 w-56" />
    </div>
  </section>
);
